import {createContext, useContext, useRef} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {createPortal} from 'react-dom';
import {CSSTransition} from 'react-transition-group';
import {Typography} from '../atoms/Typography';
import {Button} from '../atoms/Button';
import {CloseLineIcon} from '../svg/CloseLineIcon';

export const BottomSheet = (props) => {
  const {onClose, 'data-qa-id': dataQaId = 'bottom-sheet'} = props;
  const fadeRef = useRef(null);
  const slideRef = useRef(null);
  return (
    <BottomSheetPortal {...props}>
      <Fade ref={fadeRef}>
        <div ref={fadeRef}>
          <Button
            variant="unstyled-button"
            className="bottom-sheet__overlay"
            onClick={onClose}
            aria-label="Close"
            data-qa-id={`${dataQaId}__overlay`}
          />
          <SlideUp ref={slideRef}>
            <Sheet ref={slideRef} {...props} />
          </SlideUp>
        </div>
      </Fade>
    </BottomSheetPortal>
  );
};

BottomSheet.propTypes = {
  in: PropTypes.bool,
  onClose: PropTypes.func,
  content: PropTypes.node,
  'data-qa-id': PropTypes.string,
};

const BottomSheetPortalContext = createContext(null);

const BottomSheetPortal = (props) => {
  const {aboveOtherModals} = props;
  return createPortal(
    <BottomSheetPortalContext.Provider value={props}>
      <div
        className={cx('bottom-sheet__portal', {
          'bottom-sheet__portal__above-others': aboveOtherModals,
        })}
      >
        {props.children}
      </div>
    </BottomSheetPortalContext.Provider>,
    document.body
  );
};

const Fade = ({children, ref}) => {
  const {in: IN} = useContext(BottomSheetPortalContext);

  return (
    <CSSTransition in={IN} timeout={300} nodeRef={ref} classNames="fade" unmountOnExit>
      {children}
    </CSSTransition>
  );
};

const SlideUp = ({children, ref}) => {
  const {in: IN} = useContext(BottomSheetPortalContext);

  return (
    <CSSTransition in={IN} timeout={300} nodeRef={ref} classNames="slide-up" appear unmountOnExit>
      {children}
    </CSSTransition>
  );
};

const Sheet = ({content, title, onClose, className, ref}) => (
  <div className={cx('bottom-sheet', className)} ref={ref}>
    {title && (
      <div className="bottom-sheet__header">
        <Typography variant="header5">{title}</Typography>
        <Button variant="unstyled-button" aria-label="Close" onClick={onClose}>
          <CloseLineIcon ratio={0.75} />
        </Button>
      </div>
    )}
    {content ?? null}
  </div>
);
